<template>
  <custom-form
    action="api/v1/cryptoLimits"
    @submitted="$emit('limitCreated', $event)"
    @on-error="handleErrors"
    ref="form"
  >
    <select-currency
      :error-messages="currencyError"
      @selected="setCurrencyId"
      hint="Selecting an existing currency will update it instead"
      persistent-hint
    />
    <custom-input
      name="daily"
      type="number"
      label="Daily Limit"
      prepend-inner-icon="mdi-calendar-today"
    />
    <custom-input
      name="weekly"
      type="number"
      label="Weekly Amount"
      prepend-inner-icon="mdi-calendar-week"
    />
    <custom-input
      name="monthly"
      type="number"
      label="Monthly Amount"
      prepend-inner-icon="mdi-calendar-month-outline"
    />
    <custom-input
      name="annually"
      type="number"
      label="Annual Amount"
      prepend-inner-icon="mdi-calendar-blank"
    />

    <v-alert type="error" dense text v-if="genericError" v-text="genericError" />

    <custom-button color="primary" large raised tile block>
      <v-icon>mdi-wallet-plus</v-icon>
      Register Limit
    </custom-button>
  </custom-form>
</template>
<script>
import SelectCurrency from "@/app/crypto/selectCurrency";

export default {
  components: { SelectCurrency },
  props: {
    userId: { type: String, required: false },
  },
  data() {
    return {
      currencyError: null,
      genericError: null,
    };
  },
  methods: {
    setCurrencyId(currency) {
      this.currencyError = null;
      this.$refs.form.updateFieldValue("currency_id", currency && currency.id);
    },
    handleErrors(errors) {
      this.currencyError = this.objectValueFromPath(errors, "data.errors.currency_id.0");
      this.genericError = this.objectValueFromPath(errors, "data.errors.error.0");
    },
    setFormUserId(id) {
      if (id && this.$refs.form) {
        this.$refs.form.updateFieldValue("user_id", id);
      }
    },
  },
  mounted() {
    this.setFormUserId(this.userId);
  },
  watch: {
    userId(id) {
      this.setFormUserId(id);
    },
  },
};
</script>
